import { get, writable } from 'svelte/store'
import api from '../../app/api'
import uuidv4 from 'uuid/v4'
import {documentTypes} from "./document-types"
import { navigate } from "svelte-routing"

export const uploadDocumentTypes = {
    CZECH_ID_2021: 'CZECH_ID_2021',
    CZECH_ID_2012: 'CZECH_ID_2012',
    CZECH_ID_2005: 'CZECH_ID_2005',
    SLOVAK_ID: 'SLOVAK_ID',
    CZECH_ID_2021_DRIVING_LICENSE: 'CZECH_ID_2021_DRIVING_LICENSE',
    CZECH_ID_2012_DRIVING_LICENSE: 'CZECH_ID_2012_DRIVING_LICENSE',
    CZECH_ID_2005_DRIVING_LICENSE: 'CZECH_ID_2005_DRIVING_LICENSE',
    CZECH_ID_2021_PASSPORT: 'CZECH_ID_2021_PASSPORT',
    CZECH_ID_2012_PASSPORT: 'CZECH_ID_2012_PASSPORT',
    CZECH_ID_2005_PASSPORT: 'CZECH_ID_2005_PASSPORT',
}

function uploadFilesStore() {
    const isReading = writable(false)
    const recognitionResult = writable({})
    const uploadedFiles = writable([])

    function detect(file) {
        let formData = new FormData()
        formData.append('document', file)
        const id = uuidv4()
        uploadedFiles.update(files => [
            ...files,
            {
                id,
                file,
                isUploading: true,
                isValid: false,
                type: []
            }
        ])
        api.detect(formData).then(
            result => {
                console.log('detection uuid', result)
                uploadedFiles.update(files => {
                    const uploadedFile = files.find(file => file.id === id)
                    const uuid = result.data
                    uploadedFile.uuid = uuid
                    detectionResult(uuid)
                    return [...files]
                })
            }
        )
    }

    function detectionResult(uuid) {
        const uploadInterval = setInterval(() => {
            api.detectionResult(uuid).then(
                result => {
                    if (result.status === 202) {
                        return
                    }
                    if (result.status === 200) {
                        console.log('detection result', result)
                        uploadedFiles.update(files => {
                            const fileIndex = files.findIndex(f => f.uuid === uuid)
                            const documents =  result.data.result.documents
                            files[fileIndex].isUploading = false
                            if (documents.length) {
                                files[fileIndex].isValid = true
                                files[fileIndex].error = ''
                            } else {
                                files[fileIndex].isValid = false
                                files[fileIndex].error = 'No document detected'
                            }
                            files[fileIndex].type = result.data.result.documents
                            console.log(result.data.result.documents)
                            return [...files]
                        })
                    } else {
                        uploadedFiles.update(files => {
                            const fileIndex = files.findIndex(f => f.uuid === uuid)
                            files[fileIndex].isUploading = false
                            files[fileIndex].isValid = false
                            files[fileIndex].error = 'Unknown error'
                            return files
                        })
                    }
                    window.clearInterval(uploadInterval)
                },
                error => {
                    uploadedFiles.update(files => {
                        const fileIndex = files.findIndex(f => f.uuid === uuid)
                        files[fileIndex].isUploading = false
                        files[fileIndex].isValid = false
                        files[fileIndex].error = error.data.error
                        return files
                    })
                    window.clearInterval(uploadInterval)
                }
            )
        }, 500)
    }

    function upload() {
        const files = get(uploadedFiles);
        const idFront2021 = files.find(file => file.type.includes(documentTypes.id_2021_front))
        const idFront2012 = files.find(file => file.type.includes(documentTypes.id_2012_front))
        const idBack2012 = files.find(file => file.type.includes(documentTypes.id_2012_back))
        const idFront2005 = files.find(file => file.type.includes(documentTypes.id_2005_front))
        const idBack2005 = files.find(file => file.type.includes(documentTypes.id_2005_back))
        const idFrontSK = files.find(file => file.type.includes(documentTypes.id_svk_front))
        const idBackSK = files.find(file => file.type.includes(documentTypes.id_svk_back))
        const drivingLicense = files.find(file => file.type.includes(documentTypes.driving_license))
        const passport2006 = files.find(file => file.type.includes(documentTypes.passport_2006))
        isReading.set(true)
        const idFront = idFront2021 || idFront2012 || idFront2005 || idFrontSK
        const idBack = idBack2012 || idBack2005 || idBackSK

        let formData = new FormData()
        formData.append('id-front', idFront.file)
        formData.append('id-back', idBack.file)
        if (drivingLicense) {
            formData.append('additional', drivingLicense.file)
        }
        else if (passport2006) {
            formData.append('additional', passport2006.file)
        }

        let type
        if (idFront.type.includes(documentTypes.id_2021_front) && idBack.type.includes(documentTypes.id_2012_back) && drivingLicense && drivingLicense.type.includes(documentTypes.driving_license)) {
            type = uploadDocumentTypes.CZECH_ID_2021_DRIVING_LICENSE
        }
        else if (idFront.type.includes(documentTypes.id_2021_front) && idBack.type.includes(documentTypes.id_2012_back) && passport2006 && passport2006.type.includes(documentTypes.passport_2006)) {
            type = uploadDocumentTypes.CZECH_ID_2021_PASSPORT
        }
        else if (idFront.type.includes(documentTypes.id_2012_front) && idBack.type.includes(documentTypes.id_2012_back) && drivingLicense && drivingLicense.type.includes(documentTypes.driving_license)) {
            type = uploadDocumentTypes.CZECH_ID_2012_DRIVING_LICENSE
        }
        else if (idFront.type.includes(documentTypes.id_2012_front) && idBack.type.includes(documentTypes.id_2012_back) && passport2006 && passport2006.type.includes(documentTypes.passport_2006)) {
            type = uploadDocumentTypes.CZECH_ID_2012_PASSPORT
        }
        else if (idFront.type.includes(documentTypes.id_2005_front) && idBack.type.includes(documentTypes.id_2005_back) && drivingLicense && drivingLicense.type.includes(documentTypes.driving_license)) {
            type = uploadDocumentTypes.CZECH_ID_2005_DRIVING_LICENSE
        }
        else if (idFront.type.includes(documentTypes.id_2005_front) && idBack.type.includes(documentTypes.id_2005_back) && passport2006 && passport2006.type.includes(documentTypes.passport_2006)) {
            type = uploadDocumentTypes.CZECH_ID_2005_PASSPORT
        }
        else if (idFront.type.includes(documentTypes.id_2021_front) && idBack.type.includes(documentTypes.id_2012_back)) {
            type = uploadDocumentTypes.CZECH_ID_2021
        }
        else if (idFront.type.includes(documentTypes.id_2012_front) && idBack.type.includes(documentTypes.id_2012_back)) {
            type = uploadDocumentTypes.CZECH_ID_2012
        }
        else if (idFront.type.includes(documentTypes.id_2005_front) && idBack.type.includes(documentTypes.id_2005_back)) {
            type = uploadDocumentTypes.CZECH_ID_2005
        }
        else if (idFront.type.includes(documentTypes.id_svk_front) && idBack.type.includes(documentTypes.id_svk_back)) {
            type = uploadDocumentTypes.SLOVAK_ID
        }

        if (!type) return
        api.upload({data: formData, type}).then(
            result => {
                console.log('upload uuid', result)
                uploadResult(result.data)
            },
            () => {
                //error
            }
        )
    }

    function uploadResult(uuid) {
        const resultInterval = setInterval(() => {
            api.result(uuid).then(
                result => {
                    if (result.status === 202) {
                        return
                    }
                    if (result.status === 200) {
                        console.log('upload result', result)
                        recognitionResult.update(() => result.data)
                    }
                    window.clearInterval(resultInterval)
                    isReading.set(false)
                    navigate('/results')
                },
                () => {
                    window.clearInterval(resultInterval)
                    isReading.set(false)
                }
            )
        }, 1000)
    }

    function remove(id) {
        uploadedFiles.update(files => {
            return files.filter(file => file.id !== id)
        })
    }

    function clean() {
        recognitionResult.set({})
        uploadedFiles.set([])
    }

    return {
        isReading,
        recognitionResult,
        subscribe: uploadedFiles.subscribe,
        upload,
        detect,
        remove,
        clean
    }
}

export default uploadFilesStore()

